import "../../styles/components/BookCircle.css";
const BookCircle = ({ status }) => {
 
  return (
    <div className={`book-circle ${status}`}>
      <div></div>
    </div>
  )
};
export default BookCircle;
